module.exports = __webpack_public_path__ + "static/media/trash-red.d8254a46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/trash-red.svg
// module id = 264
// module chunks = 0